export default __webpack_public_path__ + "static/media/4431ddb07e57f43a3b5b52210947c742.svg";